import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CatalystsProvider as Provider } from '../../components/context/catalysts-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllCatalystsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Catalysts" } }) {
    nodes {
      data
    }
  }
}
`;

export const CatalystsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
